














































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Axios from 'axios';
import { pretension } from '@/utils/config';
import {
  HistoryItem, HistoryRow, mergeHistory,
} from '@/utils/pretensionStatusHistoryDisplay';
import { SheetEvent, SheetEventSeverity, PretensionEventsApiResponse } from '@/types/sheetEvents';


/**
 * История претензии в карточке — та же кнопка и боковая панель, что «История обработки» листа
 * (SheetEventsDrawer), чтобы пользователь искал историю в одном месте. Переходы статусов приходят
 * с карточкой; события (оплаты из 1С, 12019) — отдельным запросом в pretension_event, с бейджем
 * непрочитанных warning/error, как у листа.
 */
@Component
export default class PretensionHistoryDrawer extends Vue {
  @Prop({ required: true }) readonly pretensionId!: number;

  @Prop({ required: true }) readonly rows!: Array<HistoryRow>;

  @Prop({ default: false }) readonly loading!: boolean;

  open = false;

  events: Array<SheetEvent> = [];

  eventsLoading = false;

  eventsError = false;

  unreadCount = 0;

  shownDetails: Array<number> = [];

  get items(): Array<HistoryItem> {
    return mergeHistory(this.rows, this.events);
  }

  mounted(): void {
    this.loadEvents(false);
  }

  @Watch('pretensionId')
  onPretensionIdChanged(): void {
    this.events = [];
    this.unreadCount = 0;
    this.loadEvents(false);
  }

  openDrawer(): void {
    this.open = true;
    // markSeen=1 только здесь: бейдж гаснет, когда ленту действительно открыли.
    this.loadEvents(true);
  }

  refresh(): void {
    this.$emit('refresh');
    this.loadEvents(true);
  }

  async loadEvents(markSeen: boolean): Promise<void> {
    if (!this.pretensionId) {
      return;
    }
    this.eventsLoading = true;
    this.eventsError = false;
    try {
      const response = await Axios.get<PretensionEventsApiResponse>(
        pretension.events,
        { params: { pretensionId: this.pretensionId, markSeen: markSeen ? 1 : 0 } },
      );
      this.events = response.data.events || [];
      // Счётчик посчитан до сдвига курсора: при открытии панели гасим его сразу.
      this.unreadCount = markSeen ? 0 : (response.data.unread_count || 0);
    } catch (e) {
      // Переходы статусов всё равно показываем: они пришли с карточкой.
      this.eventsError = true;
    } finally {
      this.eventsLoading = false;
    }
  }

  toggleDetails(eventId: number): void {
    this.shownDetails = this.shownDetails.includes(eventId)
      ? this.shownDetails.filter((id) => id !== eventId)
      : [...this.shownDetails, eventId];
  }

  severityColor(severity: SheetEventSeverity): string {
    return { error: 'error', warning: 'warning', info: 'grey lighten-1' }[severity];
  }

  severityIcon(severity: SheetEventSeverity): string {
    return { error: 'mdi-alert-circle', warning: 'mdi-alert', info: 'mdi-cash-check' }[severity];
  }

  /** Время по МСК с подписью, как в ленте листа: у пользователя вне Москвы часы не разъедутся. */
  formatMoscow(value: string | null): string {
    if (!value) return '';
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString('ru-RU', {
      timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  }
}
